var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalSubstituerArticle",
      attrs: {
        size: "xl",
        title: "Substitution d'article",
        "ok-title": "Choisir",
        "ok-disabled": !_vm.choixValide,
        "cancel-title": "Annuler",
        "no-close-on-backdrop": ""
      },
      on: {
        ok: function($event) {
          return _vm.valider()
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", { staticClass: "ml-1" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-2 small" }, [
              _vm._v("Quantité demandée")
            ]),
            _vm.articleSelectionne.produitId &&
            _vm.articleSelectionne.designation
              ? _c("div", { staticClass: "col-10 small" }, [
                  _vm._v("Article sélectionné pour substitution")
                ])
              : _c("div", { staticClass: "col-10 small" }, [
                  _vm._v("Ingrédient sélectionné")
                ])
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-2" }, [
              _c("h5", [
                _vm._v(
                  _vm._s(_vm.articleOrigine.quantiteBesoinEnUC) +
                    " " +
                    _vm._s(_vm.articleOrigine.uc)
                )
              ])
            ]),
            _c("div", { staticClass: "col-10" }, [
              _c("h5", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.articleSelectionne.produitId &&
                        _vm.articleSelectionne.designation
                        ? _vm.articleSelectionne.designation.toUpperCase()
                        : _vm.nomIngredient.toUpperCase()
                    ) +
                    " " +
                    _vm._s(
                      _vm.articleSelectionne.marque
                        ? " - " + _vm.articleSelectionne.marque
                        : ""
                    ) +
                    " " +
                    _vm._s(
                      _vm.articleSelectionne.fournisseurId
                        ? " - " +
                            _vm.fournisseurNom(
                              _vm.articleSelectionne.fournisseurId
                            )
                        : ""
                    )
                ),
                _c("br"),
                _vm.articleSelectionne.prixUnitaire && _vm.articleSelectionne.uc
                  ? _c("span", [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.articleSelectionne.prixUnitaire) +
                          " € / " +
                          _vm._s(_vm.articleSelectionne.uc) +
                          ", prix total: " +
                          _vm._s(
                            _vm._f("afficherPrix")(
                              _vm.articleOrigine.quantiteBesoinEnUC *
                                _vm.articleSelectionne.prixUnitaire
                            )
                          ) +
                          ")"
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "flex-start ml-1 mt-3 mb-1 small" }, [
          _vm._v(
            "Articles associés à l'ingrédient \"" +
              _vm._s(_vm.nomIngredient) +
              '"'
          )
        ]),
        _vm.articles.parProduit
          ? _c(
              "div",
              [
                _c("ArticlesParProduit", {
                  attrs: {
                    articles: _vm.articles.parProduit,
                    favoris: _vm.articles.favoris,
                    articleOrigine: _vm.articleOrigine
                  },
                  on: {
                    "selection-article": function($event) {
                      return _vm.selectionnerArticle($event)
                    },
                    "validation-article": function($event) {
                      return _vm.valider()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }